/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import { DownloadIcon } from '../checkIcon';
import OtherEvent from './otherEvent';
import SuccessToolTip from './successToolTip';
import './download.scss';
import '../checkout.scss';

type PropsType = {
  downloadTicket: () => void,
  otherEvents?: []
};
 const DownloadForm = (props: PropsType): React.Element<'div'> => {
   const { downloadTicket, otherEvents } = props;

   const [isToolTipOpen, setIsToolTipOpen] = React.useState(false);

    const showTooltip = () => {
      setIsToolTipOpen(true);
      setTimeout(() => {
       setIsToolTipOpen(false);
      }, 2000);
    };


  return (
    <div className="sparxo-checkout-download_container">
    <div className="sparxo-checkout_title">Thank you!</div>
    <div className="sparxo-checkout-download_desc">An email confirmation has been sent to you regarding your purchase.
      Please be sure to also check your spam folder
    </div>
    <div className="sparxo-checkout-download_btnContainer">
        <button onClick={(): void => showTooltip()} className="sparxo-checkout_action_btn">
        <DownloadIcon className="sparxo-checkout-download_downloadIcon"/>
          Download your ticket(s)
        </button>
          <SuccessToolTip isOpen={isToolTipOpen} />
    </div>
    <div className="sparxo-checkout_title">Other events by this producer</div>
        {
          !!_.size(otherEvents) && otherEvents.map((el: {}): React.Element<'div'> => {
            return (
              <OtherEvent key={el.id} event={el}/>
            );
          })
        }
  </div>
  );
};

export default DownloadForm;
